export enum FundingActionTypes {
  FETCH_FUNDINGS = 'FETCH_FUNDINGS',
  FETCH_FUNDINGS_SUCCESS = 'FETCH_FUNDINGS_SUCCESS',
  FETCH_FUNDING_BY_REFERENCE = 'FETCH_FUNDING_BY_REFERENCE',
  FETCH_FUNDING_BY_REFERENCE_SUCCESS = 'FETCH_FUNDING_BY_REFERENCE_SUCCESS',
  FETCH_EXPORTS = 'FETCH_EXPORTS',
  FETCH_EXPORTS_SUCCESS = 'FETCH_EXPORTS_SUCCESS',
  CLEAR_FILTER = 'CLEAR_FILTER',
  SEARCH_REQUEST = 'SEARCH_REQUEST',
  SEARCH_REQUEST_REFERENCE = 'SEARCH_REQUEST_REFERENCE',
  EXPORT_REQUEST = 'EXPORT_REQUEST',
  SET_IS_EXPORTING = 'SET_IS_EXPORTING',
  SEARCH_REQUEST_FAILED = 'SEARCH_REQUEST_FAILED',
  SEARCH_REQUEST_REFERENCE_FAILED = 'SEARCH_REQUEST_REFERENCE_FAILED',
  EXPORT_REQUEST_ERROR = 'EXPORT_REQUEST_ERROR',
  CLEAR_EXPORT = 'CLEAR_EXPORT',
  DELETE_SELECTED_FUNDINGS = 'DELETE_SELECTED_FUNDINGS',
  DELETE_SELECTED_FUNDINGS_RESPONSE = 'DELETE_SELECTED_FUNDINGS_RESPONSE',
  CLEAR_DELETE_SELECTED_FUNDINGS = 'CLEAR_DELETE_SELECTED_FUNDINGS',
  UPLOAD_FUNDING_DATA = 'UPLOAD_FUNDING_DATA',
  UPLOAD_FUNDING_DATA_SUCCESS = 'UPLOAD_FUNDING_DATA_SUCCESS',
  UPLOAD_FUNDING_DATA_FAILED = 'UPLOAD_FUNDING_DATA_FAILED',
  CLEAR_UPLOAD_FUNDING_DATA = 'CLEAR_UPLOAD_FUNDING_DATA',
  GET_FRAMEWORK_PROGRAMME = 'GET_FRAMEWORK_PROGRAMME',
  SUCCESS_GET_FRAMEWORK_PROGRAMME = 'SUCCESS_GET_FRAMEWORK_PROGRAMME',
  UPLOADED_FILE = 'UPLOADED_FILE',
  FETCH_ADMIN_EMAILS = 'FETCH_ADMIN_EMAILS',
  FETCH_ADMIN_EMAILS_SUCCESS = 'FETCH_ADMIN_EMAILS_SUCCESS',
}

export const setUploadedFile = (uploadedFile: any) => (
  {
    type: 'UPLOADED_FILE',
    payload: uploadedFile,
  });

export const setIsExporting = (isExporting: boolean) => ({
  type: 'SET_IS_EXPORTING',
  payload: isExporting,
});

export const setClearExporting = () => ({
  type: 'CLEAR_EXPORT',
})

export const setSearchRequestFailed = (isSearchRequestFailed: boolean) => ({
  type: 'SEARCH_REQUEST_FAILED',
  payload: isSearchRequestFailed
})

export const setSearchRequestReferenceFailed = (isSearchRequestFailed: boolean) => ({
  type: 'SEARCH_REQUEST_REFERENCE_FAILED',
  payload: isSearchRequestFailed,
})

export const setExportRequestError = (error: boolean, loading: boolean) => ({
  type: 'EXPORT_REQUEST_ERROR',
  payload: error,
  loading: loading
})

export const getFramewokProgramme = () => ({
  type: FundingActionTypes.GET_FRAMEWORK_PROGRAMME,
});

export const successGetFramewokrProgramme = (data: any[]) => ({
  type: FundingActionTypes.SUCCESS_GET_FRAMEWORK_PROGRAMME,
  payload: data,
});

// Action creator for successful funding fetch
export const fetchFundings = (data: any[], totalPages: number, totalRecord: number, currentPage: number, pageSize: number, frameworkProgramme: any = [], status: any = []) => ({
  type: FundingActionTypes.FETCH_FUNDINGS_SUCCESS,
  payload: data,
  totalPage: totalPages,
  totalRecord: totalRecord,
  currentPage: currentPage,
  pageSize: pageSize,
  frameworkProgramme: frameworkProgramme,
  status: status
});

// Action creator for successful funding fetch by reference
export const fetchFundingByReference = (data: any) => ({
  type: FundingActionTypes.FETCH_FUNDING_BY_REFERENCE_SUCCESS,
  payload: data,
});

export const fetchExports = (data: any[]) => ({
  type: FundingActionTypes.FETCH_EXPORTS_SUCCESS,
  payload: data,
});

export const searchRequestFundingReference = (payload: {
  reference: string;
}) => ({
  type: FundingActionTypes.SEARCH_REQUEST_REFERENCE,
  payload,
})

// Action creator for searching with filters
export const searchRequestFundings = (payload: {
  frameworkProgramme: string;
  status: string;
  limit: number;
  offset: number;
}) => ({
  type: FundingActionTypes.SEARCH_REQUEST,
  payload,
});

export const exportRequest = (payload: {
  frameworkProgramme: string,
  status: string;
}) => ({
  type: FundingActionTypes.EXPORT_REQUEST,
  payload,
});

export const uploadFundingData = (payload: { formData: FormData }) => ({
  type: FundingActionTypes.UPLOAD_FUNDING_DATA,
  payload
});

export const clearUploadFundingData = () => ({
  type: FundingActionTypes.CLEAR_UPLOAD_FUNDING_DATA,
});

export const clearDeleteSelectedFunding = () => ({
  type: FundingActionTypes.CLEAR_DELETE_SELECTED_FUNDINGS,
})

export const uploadFundingDataSuccess = (res: any) => ({
  type: FundingActionTypes.UPLOAD_FUNDING_DATA_SUCCESS,
  payload: res,
});

export const uploadFundingDataFailed = (error: any) => ({
  type: FundingActionTypes.UPLOAD_FUNDING_DATA_FAILED,
  payload: error,
});

export const deleteSelectedFundings = (payload: { references: string[] }) => ({
  type: FundingActionTypes.DELETE_SELECTED_FUNDINGS,
  payload,
});

export const deleteSelectedFundingsResponse = (res: any) => ({
  type: FundingActionTypes.DELETE_SELECTED_FUNDINGS_RESPONSE,
  payload: res,
});

export const fetchAdminEmails = () => ({
  type: FundingActionTypes.FETCH_ADMIN_EMAILS,
});

export const fetchAdminEmailsSuccess = (emails: string[]) => ({
  type: FundingActionTypes.FETCH_ADMIN_EMAILS_SUCCESS,
  payload: emails,
});
